export default __webpack_public_path__ + "static/programmer-amico-092b53d435bbaab8cf591c118ceedf65.svg";